import $ from 'jquery';
import EFOcats_event_core from './efocats_event_core.js';
import EFOcats_import_html from '../import/efocats_import_html.js';
/**
 * [data-type="birthday"]でキー入力イベント
 */
export default class EFOcats_event_birthday extends EFOcats_event_core {
  /**
   * コンストラクタ
   * @param {*} default_text 日付のデフォルト選択肢のテキスト
   */
  constructor(default_text = '') {
    super();
    this.default_text = default_text;
  }

  /**
   * イベントための事前の仕込み
   */
  init() {
    if (this.$('[data-type="birthday"]').length) {
      this.$('[data-type="birthday"]').each((index, element) => {
        $(element).parents('section').addClass('birthday');
      });
    }
  }

  /**
   * イベント本体をセット
   */
  event() {
    // テキストの場合
    this.event_text();

    // selectの場合
    this.event_select();
  }

  /**
   * selectの場合
   */
  event_select() {
    this.$('.qa.birthday select').on('change', event => {
      const element = event.currentTarget;
      const inputs = $(element).parents('.qa').find('select');
      // 年と月に値がある場合だけ実行する
      if (!inputs.eq(0).val() || !inputs.eq(1).val()) {
        return;
      }
      // 日にちを覚えておく
      const day = inputs.eq(2).val();
      // 月末日計算
      const dt = new Date(inputs.eq(0).val(), inputs.eq(1).val(), 1);
      dt.setDate(dt.getDate() - 1);
      const lastday = dt.getDate();
      // 日にちの選択肢を再構築
      inputs.eq(2).empty();
      inputs.eq(2).append(EFOcats_import_html.getValue('select-question-option', {val: '', text: this.default_text}));
      for (let i = 1; i <= lastday; i++) {
        inputs.eq(2).append(EFOcats_import_html.getValue('select-question-option', {val: i, text: i}));
      }
      // 日にちを再選択
      inputs.eq(2).val(day);
      // ok-flagを外してエラーチェックが実行されるようにする
      if (!inputs.eq(2).val()) {
        inputs.eq(2).parents('.check-flag').removeClass('ok-flag');
      }
    });
  }

  /**
   * テキストの場合
   */
  event_text() {
    this.$('input[data-type="birthday"][type="text"]').keyup(event => {
      const element = event.currentTarget;

      const selIdx = $(element).val().length;

      if (event.keyCode !== 8) {
        if (selIdx === 4) {
          const val = $(element).val();
          if (val.slice(-1).match(/[0-9]/)) {
            $(element).val(`${val}/`);
          }
        } else if (selIdx === 7) {
          const val = $(element).val();
          if (val.slice(-1).match(/[0-9]/)) {
            $(element).val(`${val}/`);
          }
        }
      }
    });
  }
}
